module.exports = __webpack_public_path__ + "static/pattern19-fcb1692c32e9335e653f644cfb13d144.png";